import React, { useEffect } from 'react'
import MyPageTemplate from './components/templates/mypage_template'
import useUser from './hooks/use_user'
import { useSpBreakPoint } from '../../hooks/use_sp_breakpoint'
import UserCard from './components/cards/user_card'
import PagiNationCursor from '../../components/pagination/pagination_cursor'
import LoadingSpinner from '../../components/loading/loading_spinner'
import useBlockUsers from './hooks/use_block_users'

const MyPageBlocks = () => {
  const PAGE_SIZE = 20

  const isSp = useSpBreakPoint()
  const [user, userLoading] = useUser()
  const [blocks, totalSize, cursor, blockLoading, blocksHandler] = useBlockUsers()

  useEffect(() => {
    if (user) {
      blocksHandler.load(user.id)
    }
  }, [user])

  const IndexSectionRef = React.createRef<HTMLDivElement>()
  const scrollToIndexSection = () => {
    if (IndexSectionRef.current) {
      const elementPosition =
        IndexSectionRef.current.getBoundingClientRect().top + window.scrollY
      const offsetPosition = elementPosition - 100
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  const blockElems = (
    <>
      <div className="rounded-xl overflow-hidden bg-white">
        {blocks?.map((item, index) => {
          return (
            <div key={`block-${String(index)}`}>
              <UserCard
                user={item}
                isBlocked
                onBlock={blocksHandler.block}
              />
            </div>
          )
        })}
      </div>
      {blocks.length === 0 && !blockLoading && (
        <div className="text-center py-4 text-gray-400">
          ブロックしているユーザーはいません
        </div>
      )}
    </>
  )

  const paginationCursor =
    blocks.length > 0 ? (
      <PagiNationCursor
        pageCount={Math.ceil(totalSize / PAGE_SIZE)}
        numRange={3}
        activePageNum={Math.floor(cursor / PAGE_SIZE) + 1}
        next={() => {
          scrollToIndexSection()
          if (user) {
            blocksHandler.load(user.id, cursor + PAGE_SIZE)
          }
        }}
        prev={() => {
          scrollToIndexSection()
          if (user) {
            blocksHandler.load(user.id, cursor - PAGE_SIZE)
          }
        }}
        jump={(pageNum: number) => {
          scrollToIndexSection()
          if (user) {
            blocksHandler.load(user.id, (pageNum - 1) * PAGE_SIZE)
          }
        }}
      />
    ) : null

  return (
    <MyPageTemplate
      userLoading={userLoading}
      head="ブロックしたユーザー"
      user={user}
      isSp={isSp}
      subHead={userLoading ? '' : `${totalSize.toLocaleString()}ユーザー`}
    >
      <div ref={IndexSectionRef} />
      {blockLoading || userLoading ? (
        <LoadingSpinner className="mx-auto" />
      ) : (
        <>
          <div className="pb-8">{blockElems}</div>
          <div className="pb-8">{paginationCursor}</div>
        </>
      )}
    </MyPageTemplate>
  )
}

export default MyPageBlocks
